import styled, { css } from 'styled-components';
import { Common, color } from '@stockbit/ui';
import { IButtonDropdownTrigger } from './types';

const { Checkbox: BaseCheckbox } = Common;

export const ActionControlWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 16px 10px 16px;
`;

export const ButtonDropdownTrigger = styled.button<IButtonDropdownTrigger>`
  display: flex;
  height: 28px;
  padding: 6px 4px;
  align-items: center;
  gap: 4px;
  border-radius: 14px;
  border: 1px solid ${color.downgray};
  background: ${color.light};
  cursor: pointer;
  position: relative;

  ${({ isOpened }) =>
    isOpened &&
    css`
      background: #f6f6f6;

      #rt-filter-chevron-down {
        transform: rotate(180deg);
      }
    `}
`;

export const DropdownWrapper = styled.div`
  border: 1px solid #ededed;
  border-radius: 3px;
  min-width: 318px;
  position: absolute;
  top: 90px;
  right: 40px;
  background: ${color.light};
  width: 318px;
  z-index: 999;
`;

export const Checkbox = styled(BaseCheckbox)`
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${color.lowgray};
  }
  .ant-checkbox-inner {
    border-radius: 100% !important;
    width: 18px;
    height: 18px;
    position: relative;

    :after {
      left: 3.5px !important;
      top: 7px !important;
    }
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background: ${color.primary};
    border-color: ${color.primary}!important;
  }
  .ant-checkbox-disabled .ant-checkbox-inner {
    border-color: ${color.lowgray}!important;
    background-color: ${color.lowgray};
  }
`;
